import { Utils } from "../Utils/Utils";
import Control from "./Control";
export default class SelectControl extends Control {
    constructor(field, isMain = true) {
        var _a;
        super(field);
        this.isMain = true;
        this.allOptions = [];
        this.isMain = isMain;
        if (!Utils.isOk(this.field.placeHolder)) {
            this.field.placeHolder = " - Please Select - ";
        }
        // Store all options for filtering
        if ((_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) {
            this.allOptions = [...this.field.selectionFieldSettings.options];
        }
    }
    renderField() {
        let ret = [];
        ret.push(`<div ${this.isMain ? " data-main" : ""} id="${this.field.internalId}">`);
        if (this.field.selectionFieldSettings.allowCustomValue) {
            ret.push(`<div class="row-two-controls">`);
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" 
                group-controls=${this.field.internalId} 
                id="${this.field.internalId}_option_selection" value="0"
                ${!(this.initialValue && this.initialValue.isCustomValue) ? " checked" : ""}
        >`);
            ret.push(...this.renderSelectWithOptions());
            ret.push("</div>");
            ret.push('<div class="row-two-controls">');
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" 
                group-controls=${this.field.internalId} 
                id="${this.field.internalId}_custom_other_selection" value="1"
                ${this.initialValue && this.initialValue.isCustomValue ? " checked" : ""}
        >`);
            ret.push(`<input type="text" disabled 
                            id="${this.field.internalId}_custom_option_value" 
                            group-controls=${this.field.internalId}  
                            placeholder="Other" 
        ${this.initialValue &&
                this.initialValue.isCustomValue &&
                this.initialValue.customValue
                ? " value='" + this.initialValue.customValue + "'"
                : ""}
        >`);
            ret.push("</div>");
        }
        else {
            ret.push(...this.renderSelectWithOptions());
        }
        ret.push("</div>");
        return ret.join("");
    }
    renderPreview() {
        var _a, _b, _c;
        const initialValue = this.initialValue;
        const value = initialValue ?
            initialValue.isCustomValue
                ? initialValue.customValue
                : (_c = (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find((o) => o.optionId === (initialValue === null || initialValue === void 0 ? void 0 : initialValue.valueId))) === null || _c === void 0 ? void 0 : _c.optionValue
            : "";
        return `<span>${value !== null && value !== void 0 ? value : ""}</span>`;
    }
    renderSelectWithOptions() {
        var _a, _b;
        let ret = [];
        ret.push(`<select id=${this.field.internalId}_select ${this.isRequired() ? " required" : ""}>`);
        ret.push(`<option disabled selected value="">${this.field.placeHolder} </option>`);
        (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.forEach((option) => {
            ret.push(`<option value="${option.optionId}"${this.initialValue && this.initialValue.valueId === option.optionId
                ? " selected"
                : ""} data-descendent-required="${option.isDescendentRequired}">${option.optionValue}</option>`);
        });
        ret.push("</select>");
        return ret;
    }
    getSelectionValue() {
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        let radioValue = "0";
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radio = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]:checked`);
            radioValue = radio[0].value;
        }
        const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
        let ret = {
            isCustomValue: radioValue === "1",
            customValue: radioValue === "1" ? otherField === null || otherField === void 0 ? void 0 : otherField.value : "",
            valueId: radioValue === "0" ? selectField === null || selectField === void 0 ? void 0 : selectField.value : "",
            lovValueId: null,
        };
        return ret;
    }
    getValue() {
        return JSON.stringify(this.getSelectionValue());
    }
    validate(clearValidationMessages = true, ghostMode = false) {
        const valid = super.validate(clearValidationMessages, ghostMode);
        if (!valid) {
            let value = this.getSelectionValue();
            if (value.isCustomValue) {
                this.field.validationMessages[0] +=
                    ' Please make sure that the "Other" field is not empty.';
            }
        }
        return valid;
    }
    getRawValue() {
        let value = this.getSelectionValue();
        return value.isCustomValue ? value.customValue : value.valueId;
    }
    customValueChange() {
        const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        const radio = document.querySelector(`#control_${this.field.internalId} input[type="radio"]:checked`);
        if (radio) {
            const radioValue = radio.value;
            if (radioValue === "1") {
                selectField.disabled = true;
                otherField.disabled = false;
            }
            else {
                selectField.disabled = false;
                otherField.disabled = true;
            }
        }
    }
    afterRender() {
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radios = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]`);
            radios.forEach((radio) => radio.addEventListener("change", this.customValueChange));
        }
        // Setup parent-child filtering if parent field is specified
        this.setupParentChildFiltering();
        super.afterRender();
    }
    onChange(validate = true) {
        this.customValueChange();
        super.onChange(validate);
    }
    updateOptions(options, placeholder) {
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        // Reset options
        selectField.options.length = 0;
        // If placeholder is needed, create a disabled option for it
        if (placeholder) {
            let placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.value = "";
            placeholderOption.text = placeholder;
            selectField.appendChild(placeholderOption);
        }
        // Create options and set selected option on field when needed
        options.forEach((fieldOption) => {
            var _a;
            let option = document.createElement("option");
            if (fieldOption.optionId === ((_a = this.initialValue) === null || _a === void 0 ? void 0 : _a.valueId)) {
                option.selected = true;
            }
            option.value = fieldOption.optionId;
            option.text = fieldOption.optionValue;
            selectField.appendChild(option);
        });
    }
    /**
     * Filter options based on a parent field's selected value
     * @param parentOptionId The parent option internal id to filter by
     * @param
     */
    filterOptionsByParentOptionId(parentOptionId, isFieldRequired) {
        if (!parentOptionId) {
            // If no parent is selected, show all options
            this.updateOptions(this.allOptions, this.field.placeHolder);
            return;
        }
        // Filter options that match the parent ID
        const filteredOptions = this.allOptions.filter(option => option.parentOptionInternalId === parentOptionId || option.parentOptionInternalId === null || option.parentOptionInternalId === undefined);
        this.updateFieldRequiredAttribute(isFieldRequired);
        // Update the select control with filtered options
        this.updateOptions(filteredOptions, this.field.placeHolder);
        // show field on parent selection change, if parent selection has no child values -> hide the dropdown
        if (filteredOptions.length > 0) {
            this.show();
        }
        else {
            this.hide();
        }
        // after filtering check hide/show if DisplayIf property is set
        this.checkForDisplayIf();
        // Reset the current selection if it's no longer valid
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        if (selectField && selectField.value) {
            const isValidSelection = filteredOptions.some(opt => opt.optionId === selectField.value);
            if (!isValidSelection) {
                selectField.value = "";
                this.onChange(true);
            }
        }
    }
    /**
     * Update field required attribute and its related design
     * @param isFieldRequired
     */
    updateFieldRequiredAttribute(isFieldRequired) {
        const fieldControl = (document.querySelector(`#control_${this.field.internalId}`));
        const selectElement = (document.getElementById(`${this.field.internalId}_select`));
        const selectLabelElement = (fieldControl.querySelector("label"));
        const selectLabelRequiredElement = (selectLabelElement.querySelector('span'));
        // reset required attribute and design
        fieldControl.classList.remove('not-valid');
        selectElement.required = false;
        this.field.isRequired.staticValue = false;
        if (selectLabelRequiredElement) {
            selectLabelRequiredElement.remove();
        }
        if (isFieldRequired) {
            selectLabelElement.innerHTML += "<span class=required>*</span>";
            selectElement.required = true;
            this.field.isRequired.staticValue = true;
        }
    }
    /**
     * Setup parent-child filtering relationship
     * Listens to parent field changes and filters this control's options accordingly
     */
    setupParentChildFiltering() {
        var _a, _b, _c;
        const parentFieldId = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.parentFieldInternalId;
        if (!parentFieldId) {
            return; // No parent field specified
        }
        // show field on first load if it has a parent field
        this.hide();
        // Find the parent field
        const parentField = (_c = (_b = this.field.form) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.find(f => f.internalId === parentFieldId);
        if (!parentField || !parentField.control) {
            console.warn(`Parent field with ID "${parentFieldId}" not found for select control "${this.field.internalId}"`);
            return;
        }
        // Get the parent control's select element
        const parentSelectElement = document.querySelector(`#control_${parentFieldId} select`);
        if (!parentSelectElement) {
            console.warn(`Parent select element not found for field "${parentFieldId}"`);
            return;
        }
        // Initial filter based on current parent value
        const initialParentValue = parentSelectElement.value;
        if (initialParentValue) {
            const isDescendentRequired = this.isSelectedOptionHasDescendentRequired(parentSelectElement);
            this.filterOptionsByParentOptionId(initialParentValue, isDescendentRequired);
        }
        // Listen to parent field changes
        parentSelectElement.addEventListener('change', () => {
            const isDescendentRequired = this.isSelectedOptionHasDescendentRequired(parentSelectElement);
            const parentValue = parentSelectElement.value;
            this.filterOptionsByParentOptionId(parentValue, isDescendentRequired);
        });
    }
    /**
     * Check if selected option should have the descendent element required
     * @param selectElement the select element
     * @returns
     */
    isSelectedOptionHasDescendentRequired(selectElement) {
        // Get the selected option element
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        // Read the data-descendent-required attribute
        const isDescendentRequired = selectedOption.dataset.descendentRequired == "true";
        return isDescendentRequired;
    }
}
